/**
 * itriskreducer.js
 **/

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function itRiskReducer(state = initialState.itrisk, action) {
	switch (action.type) {
		case types.UPDATE_ITRISK: {
			return action.response || state;
		}
		case types.GET_ALL_ITRISKS: {
			return action.response || state;
		}
		case types.GET_ITRISK_BY_ID: {
			return action.response || state;
		}
		default:
			return state;
	}
}
